export default __webpack_public_path__ + "static/media/billing-overall-white.8d04e20d.svg";